import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

export function SellerHero({ heroBanner }) {
  const { translate } = useLanguage();
  const navigate = useNavigate();

  // Fallback values if API data is missing
  const titleMain =
    heroBanner?.title?.value ||
    translate("newSeller.hero.title1") ||
    "Sell Your Vehicle";
  const subtitle =
    heroBanner?.subtitle?.value ||
    translate("newSeller.hero.subtitle") ||
    "Experience nationwide exposure...";
  const buttonText =
    heroBanner?.btnText?.value ||
    translate("newSeller.hero.startSelling") ||
    "SELL WITH CONFIDENCE";
  const bgImage = heroBanner?.imageUrl?.value || "/absolute inset-0 z-0.png";
  const ctaLink = heroBanner?.btnLink?.value || "#";

  // title = "Sell Your Vehicle with Confidence"  ← comes from backend

  const parts = titleMain.split("with Confidence");

  // parts[0] → "Sell Your Vehicle " (note the trailing space)
  // parts[1] → "" or leftover if pattern doesn't match

  const main = parts[0]?.trim() || titleMain;
  const accent = titleMain.includes("with Confidence") ? "with Confidence" : "";

  return (
    <section className="relative bg-card py-8 sm:py-12 lg:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src={bgImage}
          alt="Vehicle background"
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.src = "/absolute inset-0 z-0.png";
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center"> */}
        <div className="flex justify-center items-center text-center">
          {/* <div className="space-y-6 sm:space-y-8"> */}
          <div className="space-y-6 sm:space-y-8 max-w-2xl">
            <div>
              <p className="text-primary text-xs sm:text-sm font-semibold tracking-wide mb-4">
                ▶ {translate("newSeller.hero.badge")}
              </p>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
                <span className="text-white block">{main}</span>
                {accent && <span className="text-primary block">{accent}</span>}
              </h1>
            </div>

            <p className="text-gray-400 text-sm sm:text-base leading-relaxed max-w-md">
              {subtitle}
            </p>

            {/* <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2"> */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2 justify-center">
              <button
                className="bg-primary hover:bg-primary-dark text-white px-6 sm:px-8 py-3 rounded font-semibold flex items-center justify-center gap-2 text-sm sm:text-base transition-colors"
                onClick={() =>
                  ctaLink !== "#" && (window.location.href = ctaLink)
                }
              >
                {buttonText}
                <span>→</span>
              </button>

              <button
                onClick={() => navigate("/auctions")}
                className="border border-gray-700 hover:border-gray-600 text-white px-6 sm:px-8 py-3 rounded font-semibold text-sm sm:text-base transition-colors hover:bg-bg-light"
              >
                {translate("newSeller.hero.viewLiveAuctions")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
